import React, { useState, useEffect } from 'react'
import { Message } from 'rsuite'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import CloseProjectWidget from '../../../widgets/closeProject/CloseProjectWidget'

import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'
import { getCloseOfProjectCoworkerForm } from '../../../redux/actions/closeOfProject'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import { getWithdrawRequestStatus } from '../../../redux/actions/withdrawRequest'
import WithdrawRequestStatusWidget from '../../../widgets/progressReportWidget/withdraw/WithdrawRequestStatusWidget'
import { downloadProgressFile } from '../../../redux/actions/projectProgress'
import { getProjectEvaluation } from '../../../redux/actions/projectEvaluation'
import CoworkerEvaluateThaihealthWidget from '../../../widgets/evaluatesWidgets/coworkerEvaluateThaihealthWidgets/CoworkerEvaluateThaihealthWidget'
import PropertyArisingFromProjectWidget from '../../../widgets/intellectualProperty/PropertyArisingFromProjectWidget'
import ConfirmActualResultWidget from '../../../widgets/confirmActualResultWidget/ConfirmActualResultWidget'

export default function CloseOfProject(props) {
  //ปิดโครงการ
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [withdrawRequestStatusSchema, setWithdrawRequestStatusSchema] = useState()
  const [schema, setSchema] = useState()
  const projectsProgressId = '99'
  const [evaluationId, setEvaluationId] = useState()
  const [isConfirmIP, setIsConfirmIP] = useState()

  const [confirmActualResulSchema, setConfirmActualResulSchema] = useState()
  const [confirmActualResulChecked, setConfirmActualResulChecked] = useState()

  useEffect(() => {
    if (projectId === 'mock-wait-approve') {
      setSchemas(mockSchema.model)
      setWithdrawRequestStatusSchema(mockWithdrawRequestStatus)
    } else {
      handleGetSchema(projectId)
    }
    //projectId && handleGetDownloadProgressFile(projectId)
    handleGetEvaluationSchema(projectId, projectsProgressId)
  }, [projectId])

  const handleGetEvaluationSchema = async (projectId, projectsProgressId, evaluationId) => {
    try {
      const response = await getProjectEvaluation(projectId, projectsProgressId, evaluationId)
      setSchema(response.forms)
      setEvaluationId(response.forms?.evaluationId)

      // console.log('response==>', response)
      // setSchema(mockSchema2.form)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
  }

  const handleGetSchema = async (projectId) => {
    setIsLoading(true)
    startLoading()
    try {
      // const _schema = await getCloseOfProjectForm(projectId)
      // if (_schema.success) setSchemas(_schema.model)

      const _schema = await getCloseOfProjectCoworkerForm(projectId)

      setSchemas(_schema)

      setIsConfirmIP(_schema?.forms?.intellectualProperty?.isConfirm)

      console.log(
        'response evaluation response?.forms?.confirmActualResul ==>',
        _schema?.forms?.confirmActualResul
      )

      // console.log('response evaluation response?.forms?.confirmActualResul ==>', _schema?.forms)

      setConfirmActualResulSchema(_schema?.forms?.confirmActualResul)
      setConfirmActualResulChecked(_schema?.forms?.confirmActualResulChecked)

      const _withdrawRequestStatus = await getWithdrawRequestStatus(projectId)
      setWithdrawRequestStatusSchema(_withdrawRequestStatus)
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  const handleGetDownloadProgressFile = async (projectId) => {
    startLoading()
    //setIsLoading(true)
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const progressId = schemas.forms.projectProgressId || ''
      const response = await downloadProgressFile(projectId, progressId)
      console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      console.log('error ', e)
      setIsPdfError(true)
    }
    //setIsLoading(false)
    setIsLoadingPDF(false)
    doneLoading()
  }

  const handleRefreshSchema = async () => {
    startLoading()
    try {
      // const _schema = await getCloseOfProjectForm(projectId)
      // if (_schema.success) setSchemas(_schema.model)

      const _schema = await getCloseOfProjectCoworkerForm(projectId)
      console.log('refresh close of project schema => ', _schema)
      setConfirmActualResulSchema(_schema?.forms?.confirmActualResul)
      setConfirmActualResulChecked(_schema?.forms?.confirmActualResulChecked)
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />

        {schemas?.forms?.agreementDetails && (
          <>
            <AgreementAdditionalWidgets formSchema={schemas.forms.agreementDetails} />
          </>
        )}

        {withdrawRequestStatusSchema?.forms?.withdrawRequestStatus && (
          <>
            <WithdrawRequestStatusWidget
              showCommandButton={true}
              schema={withdrawRequestStatusSchema.forms.withdrawRequestStatus}
              header={'ประวัติการเบิกจ่ายเงินงวด'}
              isCloseProject={true}
            />
            <br />
          </>
        )}

        {/* ตรงขอปิดภาคี การประเมิน */}
        {schemas?.forms?.requestNote && (
          <>
            <CoworkerEvaluateThaihealthWidget
              schema={schema}
              disabled={schemas?.forms?.requestNote?.disabled}
              evaluationId={() => setEvaluationId(true)}
            />
          </>
        )}

        {/* {schemas?.forms?.lessonSummary && (
          <>
            <LessonSummaryWidget
              showCommandButton={!schemas.forms.lessonSummary.disabled}
              schema={schemas.forms.lessonSummary}
            />
            <br />
          </>
        )} */}

        {/* {schemas?.forms?.projectEquipment && (
          <>
            <ProgressAssetWiget schema={schemas.forms.projectEquipment} />
            <br />
          </>
        )} */}

        {/* {schemas?.forms?.financialReport && (
          <>
            <FinancialReportWidget
              showCommandButton={!schemas.forms.financialReport.disabled}
              schema={schemas.forms.financialReport}
            />
            <br />
          </>
        )} */}

        {/* ข้อมูลทรัพย์สินทางปัญญา */}
        {schemas?.forms?.intellectualProperty && (
          <>
            <PropertyArisingFromProjectWidget
              showCommandButton={!schemas?.forms?.requestNote?.disabled}
              schema={schemas?.forms?.intellectualProperty}
              setConfirmIP={setIsConfirmIP}
            />
          </>
        )}

        {/* ยืนยันผลการดำเนินการจริง */}
        {confirmActualResulSchema && (
          <>
            <ConfirmActualResultWidget
              // schema={schemas?.forms?.confirmActualResul}
              // checked={schemas?.forms?.confirmActualResulChecked}
              schema={confirmActualResulSchema}
              checked={confirmActualResulChecked}
              numberOfInstallment={schemas?.forms?.confirmActualResul?.numberOfInstallment || 0}
              onSuccess={(fag) => {
                fag && handleRefreshSchema(projectId)
              }}
            />
          </>
        )}

        {schemas?.forms?.requestNote ? (
          <>
            <CloseProjectWidget
              showCommandButton={!schemas?.forms?.requestNote?.disabled}
              schema={schemas?.forms?.requestNote}
              evaluationId={!evaluationId}
              notConfirmIP={!isConfirmIP}
              // statusConfirmActualResult={schemas?.forms?.confirmActualResulChecked.overAll}
              statusConfirmActualResult={confirmActualResulChecked?.overAll}
            />
            <br />
          </>
        ) : (
          <>
            {/* <CloseProjectWidget
              showCommandButton={!mockRequestNote.disabled}
              schema={mockRequestNote}
            />
            <br /> */}
          </>
        )}

        {/* {schemas?.forms?.sendContractCloseOfProject && (
          <>
            <SendContractCloseProjectWidget
              showCommandButton={!schemas.forms.sendContractCloseOfProject.disabled}
              schema={schemas.forms.sendContractCloseOfProject}
            />
            <br />
          </>
        )} */}

        {/* {console.log('isPdfError >> ', isPdfError)} */}
        {isPdfError ? (
          <>
            <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
            <br />
          </>
        ) : (
          <>
            <PdfRenderWidgets
              file={previewPdf}
              isLoading={isLoadingPDF}
              header={'เอกสารที่เกี่ยวข้องกับการปิดโครงการ'}
              fileName={'เอกสารที่เกี่ยวข้องกับการปิดโครงการ'}
              onReload={() => handleGetDownloadProgressFile(projectId)}
              loadingMessage={'เอกสารที่เกี่ยวข้องกับการปิดโครงการ'}
              firstExpandToReload={true}
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}

const mockWithdrawRequestStatus = {
  header: 'สถานะการขอเบิกงวดเงิน mock',
  subHeader:
    'ข้อเสนอโครงการ -การพัฒนาศักยภาพผู้สูงอายุเพิ่มทักษะ ฟื้นฟูทักษะ ลดการพึ่งพาจากสังคม 344',
  disabled: false,
  forms: {
    withdrawRequestStatus: {
      name: 'withdrawRequestStatus',
      header: 'สถานะการขอเบิกงวดเงิน',
      values: [
        {
          id: '9FCDE6FA-1B59-49C6-8902-0ADB7967110E',
          projectVersionId: '64A07968-1187-449B-BEED-C6D56E184391',
          installmentNo: 1,
          startDate: '24/11/2564',
          endDate: '25/11/2564',
          installmentAmt: 300000,
          requestAmt: 300000,
          pvNo: null,
          pvDate: null,
          transferDate: null,
          statusCode: 0,
          statusName: 'รอดำเนินการ',
        },
        {
          id: '43EC3D68-CBC7-4827-BDC8-F91175C9AD30',
          projectVersionId: '64A07968-1187-449B-BEED-C6D56E184391',
          installmentNo: 2,
          startDate: '27/11/2564',
          endDate: '28/11/2564',
          installmentAmt: 300000,
          requestAmt: 300000,
          pvNo: null,
          pvDate: null,
          transferDate: null,
          statusCode: 0,
          statusName: 'รอดำเนินการ',
        },
        {
          id: 'D5479B4B-6B2C-49C6-A0D3-3036E950E025',
          projectVersionId: '64A07968-1187-449B-BEED-C6D56E184391',
          installmentNo: 3,
          startDate: '01/12/2564',
          endDate: '03/12/2564',
          installmentAmt: 200000,
          requestAmt: 200000,
          pvNo: null,
          pvDate: null,
          transferDate: null,
          statusCode: 0,
          statusName: 'รอดำเนินการ',
        },
      ],
    },
  },
}

const mockSchema = {
  affectedRows: 0,
  message: 'Successfully',
  success: true,
  didError: false,
  errorMessage: null,
  model: {
    header: 'ปิดโครงการ mock',
    subHeader:
      'ข้อเสนอโครงการ การพัฒนาศักยภาพผู้สูงอายุเพิ่มทักษะ ฟื้นฟูทักษะ ลดการพึ่งพาจากสังคม 344',
    disabled: false,
    forms: {
      agreementDetails: null,
      requestNote: {
        header: 'ปิดโครงการ',
        buttonText: 'ส่งขอปิดโครงการ',
        approveType: null,
        note: {
          name: 'Note',
          label: 'หมายเหตุ',
          value: null,
          hint: 'ระบุหมายเหตุ',
          validators: [],
        },
        closeType: {
          name: 'closeType',
          value: null,
          options: [
            { value: 1, label: 'แจ้งขอเบิกเงิน' },
            { value: 2, label: 'แจ้งโอนเงินคืน' },
          ],
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณาเลือก การแจ้งขอปิดโครงการ',
            },
          ],
        },
        refundAmount: {
          name: 'refundAmount',
          value: 0,
          label: 'เงินคืนตามใบแจ้งการฝากเงินเข้าธนาคาร (Teller Payment)',
          preLabel: 'จำนวน',
          postLabel: 'บาท',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณาเลือก การแจ้งขอปิดโครงการ',
            },
          ],
        },
        uploadDocuments: {
          disabled: false,
          header: 'ไฟล์แนบหลักฐานการโอนเงิน',
          fileList: {
            name: 'attachFiles',
            value: [],
            validators: [
              {
                type: 'REQUIRED',
                value: null,
                errorMessage: 'กรุณาแนบไฟล์ ไฟล์แนบหลักฐานการโอนเงิน',
              },
            ],
          },
        },
      },
    },
  },
}
